import { DOMAIN_CURRENCY_MAP } from '@/src/constants/domainCurrencyMap'
import { getCookie } from '../browser'
import { logError } from '../logError'

export const getUserSelectedCurrencyCode = (): string => {
    try {
        const cookieCurrency = getCookie('utm_currency')
        if (cookieCurrency) return cookieCurrency.split('|')[0]
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname
            return DOMAIN_CURRENCY_MAP[hostname]?.currency
        }
        return ''
    } catch (error) {
        logError('getUserSelectedCurrencyCode', error)
        return ''
    }
}
